export const USUARIOS_CONFIRMAR_CADASTRO_POR_TOKEN_BEGIN = 'USUARIOS_CONFIRMAR_CADASTRO_POR_TOKEN_BEGIN';
export const USUARIOS_CONFIRMAR_CADASTRO_POR_TOKEN_SUCCESS = 'USUARIOS_CONFIRMAR_CADASTRO_POR_TOKEN_SUCCESS';
export const USUARIOS_CONFIRMAR_CADASTRO_POR_TOKEN_FAILURE = 'USUARIOS_CONFIRMAR_CADASTRO_POR_TOKEN_FAILURE';
export const USUARIOS_CONFIRMAR_CADASTRO_POR_TOKEN_DISMISS_ERROR = 'USUARIOS_CONFIRMAR_CADASTRO_POR_TOKEN_DISMISS_ERROR';
export const USUARIOS_BUSCAR_PENDENTE_APROVACAO_BEGIN = 'USUARIOS_BUSCAR_PENDENTE_APROVACAO_BEGIN';
export const USUARIOS_BUSCAR_PENDENTE_APROVACAO_SUCCESS = 'USUARIOS_BUSCAR_PENDENTE_APROVACAO_SUCCESS';
export const USUARIOS_BUSCAR_PENDENTE_APROVACAO_FAILURE = 'USUARIOS_BUSCAR_PENDENTE_APROVACAO_FAILURE';
export const USUARIOS_BUSCAR_PENDENTE_APROVACAO_DISMISS_ERROR = 'USUARIOS_BUSCAR_PENDENTE_APROVACAO_DISMISS_ERROR';
export const USUARIOS_APROVAR_CADASTRO_BEGIN = 'USUARIOS_APROVAR_CADASTRO_BEGIN';
export const USUARIOS_APROVAR_CADASTRO_SUCCESS = 'USUARIOS_APROVAR_CADASTRO_SUCCESS';
export const USUARIOS_APROVAR_CADASTRO_FAILURE = 'USUARIOS_APROVAR_CADASTRO_FAILURE';
export const USUARIOS_APROVAR_CADASTRO_DISMISS_ERROR = 'USUARIOS_APROVAR_CADASTRO_DISMISS_ERROR';
export const USUARIOS_ALTERAR_SENHA_BEGIN = 'USUARIOS_ALTERAR_SENHA_BEGIN';
export const USUARIOS_ALTERAR_SENHA_SUCCESS = 'USUARIOS_ALTERAR_SENHA_SUCCESS';
export const USUARIOS_ALTERAR_SENHA_FAILURE = 'USUARIOS_ALTERAR_SENHA_FAILURE';
export const USUARIOS_ALTERAR_SENHA_DISMISS_ERROR = 'USUARIOS_ALTERAR_SENHA_DISMISS_ERROR';
export const USUARIOS_REPROVAR_CADASTRO_BEGIN = 'USUARIOS_REPROVAR_CADASTRO_BEGIN';
export const USUARIOS_REPROVAR_CADASTRO_SUCCESS = 'USUARIOS_REPROVAR_CADASTRO_SUCCESS';
export const USUARIOS_REPROVAR_CADASTRO_FAILURE = 'USUARIOS_REPROVAR_CADASTRO_FAILURE';
export const USUARIOS_REPROVAR_CADASTRO_DISMISS_ERROR = 'USUARIOS_REPROVAR_CADASTRO_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/usuarios/redux/constants.js